import {
	ICrudApplyProviderAttrFilters,
	ICrudApplyProviderAttrFiltersRes,
	ICrudApplyProviderAttrIndividual,
	ICrudApplyProviderAttrIndividualRes,
	ICrudProviderAttrGlobalAssign,
	ICrudProviderAttrGlobalAssignConfirm,
	ICrudProviderAttrGlobalAssignConfirmRes,
	ICrudProviderAttrGlobalAssignEdit,
	ICrudProviderAttrGlobalAssignEditRes,
	ICrudProviderAttrGlobalAssignPaginate,
	ICrudProviderAttrGlobalAssignPaginateRes,
	ICrudProviderAttrGlobalAssignResponse
} from 'models/ProviderGlobalUploadInterface'
import {
	CLEAR_PROVIDER_ATTR_GLOBAL,
	EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN,
	EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS,
	SET_PROVIDER_ATTR_GLOBAL_ASSIGN_SUCCESS,
	SET_PROVIDER_ATTR_GLOBAL_FILTERS,
	SET_PROVIDER_ATTR_GLOBAL_FILTERS_SUCCESS,
	SET_PROVIDER_ATTR_INDIVIDUAL,
	SET_PROVIDER_ATTR_INDIVIDUAL_SUCCESS
} from '../constants/ActionsTypes'

export const providerAttrGlobalApply = (
	payload: ICrudApplyProviderAttrFilters
) => {
	return {
		type: SET_PROVIDER_ATTR_GLOBAL_FILTERS,
		payload
	}
}

export const providerAttrGlobalApplySuccess = (
	payload: ICrudApplyProviderAttrFiltersRes
) => {
	return {
		type: SET_PROVIDER_ATTR_GLOBAL_FILTERS_SUCCESS,
		payload
	}
}
export const providerAttrIndividualApply = (
	payload: ICrudApplyProviderAttrIndividual
) => {
	return {
		type: SET_PROVIDER_ATTR_INDIVIDUAL,
		payload
	}
}

export const providerAttrIndividualApplySuccess = (
	payload: ICrudApplyProviderAttrIndividualRes
) => {
	return {
		type: SET_PROVIDER_ATTR_INDIVIDUAL_SUCCESS,
		payload
	}
}
export const providerAttrGlobalAssignConfirm = (
	payload: ICrudProviderAttrGlobalAssignConfirm
) => {
	return {
		type: SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM,
		payload
	}
}

export const providerAttrGlobalAssignConfirmSuccess = (
	payload: ICrudProviderAttrGlobalAssignConfirmRes
) => {
	return {
		type: SET_PROVIDER_ATTR_GLOBAL_ASSIGN_CONFIRM_SUCCESS,
		payload
	}
}

export const providerAttrGlobalAssignEdit = (
	payload: ICrudProviderAttrGlobalAssignEdit
) => {
	return {
		type: EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN,
		payload
	}
}

export const providerAttrGlobalAssignEditRes = (
	payload: ICrudProviderAttrGlobalAssignEditRes
) => {
	return {
		type: EDIT_PROVIDER_ATTR_GLOBAL_ASSIGN_SUCCESS,
		payload
	}
}
export const providerAttrGlobalAssign = (
	payload: ICrudProviderAttrGlobalAssign
) => {
	return {
		type: SET_PROVIDER_ATTR_GLOBAL_ASSIGN,
		payload
	}
}

export const providerAttrGlobalAssignSuccess = (
	payload: ICrudProviderAttrGlobalAssignResponse
) => {
	return {
		type: SET_PROVIDER_ATTR_GLOBAL_ASSIGN_SUCCESS,
		payload
	}
}
export const providerAttrGlobalAssignPaginate = (
	payload: ICrudProviderAttrGlobalAssignPaginate
) => {
	return {
		type: SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION,
		payload
	}
}

export const providerAttrGlobalAssignPaginateSuccess = (
	payload: ICrudProviderAttrGlobalAssignPaginateRes
) => {
	return {
		type: SET_PROVIDER_ATTR_GLOBAL_ASSIGN_PAGINATION_SUCCESS,
		payload
	}
}
export const providerCleanButton = () => ({
	type: CLEAR_PROVIDER_ATTR_GLOBAL
})
